// Language utility functions

/**
 * Check if a language is RTL (Right-to-Left)
 * @param {string} language - Language code (ar, en, ur, etc.)
 * @returns {boolean} - True if language is RTL
 */
export const isRTLLanguage = (language) => {
    const rtlLanguages = ['ar', 'ur', 'he', 'fa', 'ps']; // Arabic, Urdu, Hebrew, Persian, Pashto
    return rtlLanguages.includes(language);
};

/**
 * Get language display name
 * @param {string} language - Language code
 * @returns {string} - Display name of the language
 */
export const getLanguageDisplayName = (language) => {
    const languageNames = {
        ar: 'العربية',
        en: 'English',
        ur: 'اردو'
    };
    return languageNames[language] || language;
};

/**
 * Get available languages
 * @returns {Array} - Array of available language objects
 */
export const getAvailableLanguages = () => [
    { code: 'ar', name: 'العربية', isRTL: true },
    { code: 'en', name: 'English', isRTL: false },
    { code: 'ur', name: 'اردو', isRTL: true }
]; 